import api from "../services/index";

const organizationChartApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationChart: builder.query({
      query: (params) => ({
        url: `/api/organization/chat/contacts`,
        method: "get",
        params,
      }),
    }),
  }),
});

export default organizationChartApi;
export const { useGetOrganizationChartQuery } = organizationChartApi;
